import {
  SanitySortOption,
  SanitySortOptionType,
} from '@data/sanity/queries/types/filter'
import { SanityCollectionStrings } from '@data/sanity/queries/types/strings'
import { UrlParameter } from '@lib/url'

import CollectionListbox from './listbox'

interface CollectionSortProps {
  sortOptions: SanitySortOption[]
  activeSortValue: SanitySortOptionType | null
  collectionStrings: SanityCollectionStrings
  onChange: (newParameters: UrlParameter[]) => void
}

const CollectionSort = ({
  collectionStrings,
  sortOptions,
  activeSortValue,
  onChange,
}: CollectionSortProps) => (
  <div className="flex ml-auto px-2 sm:px-4">
    <CollectionListbox
      id="collection-sort"
      name="sort"
      label={collectionStrings.collectionSortDescription}
      options={sortOptions}
      activeOption={activeSortValue}
      onChange={onChange}
      before={
        <span className="text-sm font-semibold mr-4">
          {collectionStrings.collectionSortLabel}:
        </span>
      }
      className="flex"
    />
  </div>
)

export default CollectionSort
